// PageVariablesApolices.js

export const pageVariables = {

    listaDeAgendamentoPage: process.env.VUE_APP_API_URL+"lista-atendimento-whats",
};


